import React, { useState } from "react";
import { FiChevronDown, FiChevronUp, FiHelpCircle, FiMessageCircle } from "react-icons/fi";
 

const faqsData = [
  {
    question: "How does this platform help me find my perfect match?",
    answer:
      "Our smart compatibility system matches you with people who share your lifestyle, values, and interests — helping you find a real, meaningful connection.",
  },
  {
    question: "Are all profiles verified?",
    answer:
      "Yes! We carefully verify every profile through our secure verification process to ensure authenticity and protect our members’ trust.",
  },
  {
    question: "Can I use this platform for free?",
    answer:
      "Absolutely! You can start for free and upgrade to premium for advanced features like priority matchmaking and private chat access.",
  },
  {
    question: "Is my data safe and secure?",
    answer:
      "Your safety is our top priority. We use SSL encryption, data masking, and two-factor authentication to ensure your privacy at all times.",
  },
  {
    question: "How do I contact support?",
    answer:
      "Our support team is available 24/7. You can reach us via Contact Us Form for quick help.",
  },
];

function Faqs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faqs">
      <div className="faq-container">
        <div className="faq-header">
          <div className="faq-subtitle">
            <FiHelpCircle className="icon" /> Have Questions?
          </div>
          <h2>
            Frequently Asked <span>Questions</span>
          </h2>
          <p>
            Explore some of the most common questions to understand how our
            platform helps you connect safely and meaningfully.
          </p>
        </div>

        <div className="faq-list">
          {faqsData.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleFaq(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                {activeIndex === index ? (
                  <FiChevronUp className="icon" />
                ) : (
                  <FiChevronDown className="icon" />
                )}
              </div>

              <div
                className="faq-answer"
                style={{
                  maxHeight: activeIndex === index ? "200px" : "0px",
                }}
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <button className="chat-btn">
            <FiMessageCircle className="me-2" /> Still have questions? Chat with us
          </button>
        </div>
      </div>
    </section>
  );
}

export default Faqs;
